export default __webpack_public_path__ + "static/media/back.6a8bc3bb.svg";